export default "__VITE_PUBLIC_ASSET__50eb9d75__"